import { ReactNode } from 'react';
import { useTranslation } from '@frontend/i18n';
import { GroupParticipant } from '@frontend/thread-header-context';
import { ContactsDrawerBase, type DrawerContact } from './contacts-drawer-base';

type GroupContactsDrawerProps = {
  open: boolean;
  onClose: () => void;
  participants: GroupParticipant[];
  locationId?: string;
  onSelect?: (personId: string) => void;
  rightSlot?: ReactNode;
  compact?: boolean;
};

export const GroupContactsDrawer = ({
  open,
  onClose,
  participants,
  locationId,
  onSelect,
  rightSlot,
  compact,
}: GroupContactsDrawerProps) => {
  const { t } = useTranslation('thread-header');

  const contacts: DrawerContact[] = participants.flatMap<DrawerContact>((participant) => {
    const resolvedPersonId = participant.person?.personId;

    if (resolvedPersonId) {
      return [
        {
          personId: resolvedPersonId,
          isPrimary: true,
        },
      ];
    }

    if (participant.phoneNumber) {
      return [
        {
          phoneNumber: participant.phoneNumber,
        },
      ];
    }

    return [];
  });

  return (
    <ContactsDrawerBase
      contacts={contacts}
      title={t('Contacts In This Group')}
      count={participants.length}
      open={open}
      onClose={onClose}
      onSelect={(personId) => {
        onSelect?.(personId);
      }}
      locationId={locationId ?? ''}
      rightSlot={rightSlot}
      compact={compact}
      variant='group'
    />
  );
};
